<template>
  <div class="app-root">
    <!-- 主页 -->
    <div v-if="currentPage === 'home'" class="download-page">
      <div class="poster-scroll">
        <img class="poster-img" src="@/assets/bg.png" alt="星辰互娱" />
      </div>
      <div class="page-gradient"></div>

      <nav class="bottom-tab">
        <div class="tab-glow"></div>
        <div class="tab-panel">
          <p class="tab-panel-title">官方正版下载</p>
          <div class="tab-row-lg">
            <button class="tab-btn tab-lg tab-ios" type="button" @click="openIOS">
              <span class="tab-lg-icon">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path
                    d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
                </svg>
              </span>
              <span class="tab-lg-text">
                <span class="tab-lg-main">苹果下载</span>
                <span class="tab-lg-sub">iOS 通道</span>
              </span>
            </button>
            <button class="tab-btn tab-lg tab-android" type="button" @click="openAndroid">
              <span class="tab-lg-icon">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path
                    d="M6 18c0 .55.45 1 1 1h1v3.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V19h2v3.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V19h1c.55 0 1-.45 1-1V8H6v10zM3.5 8C2.67 8 2 8.67 2 9.5v7c0 .83.67 1.5 1.5 1.5S5 17.33 5 16.5v-7C5 8.67 4.33 8 3.5 8zm17 0c-.83 0-1.5.67-1.5 1.5v7c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5zm-4.97-5.41c.03.16.05.33.05.51 0 1.66-1.34 3-3 3s-3-1.34-3-3c0-.18.02-.35.05-.51C7.08 1.71 8.28 1 9.6 1h4.8c1.32 0 2.52.71 3.43 1.59zM12 2.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5S12.83 2.5 12 2.5z" />
                </svg>
              </span>
              <span class="tab-lg-text">
                <span class="tab-lg-main">安卓下载</span>
                <span class="tab-lg-sub">多线路</span>
              </span>
            </button>
          </div>
          <div class="tab-row-sm">
            <button class="tab-btn tab-sm tab-kefu" type="button" @click="contactSupport">
              <span class="tab-sm-icon">
                <svg viewBox="0 0 24 24" fill="none">
                  <path
                    d="M12 3C7.03 3 3 6.58 3 11c0 1.85.74 3.55 2 4.9V21l4.2-2.3c1.56.45 3.22.7 4.8.7 4.97 0 9-3.58 9-8s-4.03-8-9-8z"
                    stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" />
                </svg>
              </span>
              <span>联系客服</span>
            </button>
            <button class="tab-btn tab-sm tab-activity" type="button" @click="openActivity">
              <span class="tab-sm-icon">
                <svg viewBox="0 0 24 24" fill="none">
                  <path
                    d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"
                    stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" />
                </svg>
              </span>
              <span>热门活动</span>
              <span class="tab-badge">HOT</span>
            </button>
            <button class="tab-btn tab-sm tab-notice" type="button" @click="openNotice">
              <span class="tab-sm-icon">
                <svg viewBox="0 0 24 24" fill="none">
                  <path d="M18 8A6 6 0 106 8c0 7-3 9-3 9h18s-3-2-3-9M13.73 21a2 2 0 01-3.46 0" stroke="currentColor"
                    stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </span>
              <span>游戏公告</span>
            </button>
          </div>
        </div>
      </nav>
    </div>

    <!-- iOS 下载 -->
    <div v-else-if="currentPage === 'ios'" class="sub-page ios-page">
      <div class="sub-bg">
        <div class="orb orb-1 orb-gold"></div>
        <div class="orb orb-2"></div>
        <div class="orb orb-3"></div>
      </div>
      <header class="sub-header">
        <button class="back-btn" type="button" @click="goHome">
          <svg viewBox="0 0 24 24" fill="none">
            <path d="M15 6L9 12L15 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
          返回
        </button>
        <div class="sub-brand">星辰互娱</div>
      </header>
      <div class="sub-content">
        <div class="sub-hero">
          <h1>苹果下载中心</h1>
          <p>iOS 专属通道 · 双线路自动备用</p>
        </div>

        <section class="download-section section-primary section-ios">
          <div class="section-badge">推荐</div>
          <h2 class="section-title"><span class="section-icon">🍎</span>线路 1</h2>
          <p class="section-desc">动态 API 智能匹配，自动跳转最优安装页</p>
          <button class="dl-btn dl-btn-gold" type="button" :disabled="isIosLoading" @click="startIosRoute1">
            <span v-if="!isIosLoading">进入线路 1</span>
            <span v-else>{{ iosLoadingHint || '连接中...' }}</span>
          </button>
        </section>

        <section class="download-section">
          <h2 class="section-title"><span class="section-icon">🔗</span>线路 2</h2>
          <p class="section-desc">域名池随机分配，稳定备用通道</p>
          <button class="dl-btn dl-btn-outline dl-btn-ios-outline" type="button" :disabled="isIosLoading"
            @click="startIosRoute2">
            <span class="backup-num">02</span>
            <span class="backup-info">
              <span class="backup-name">进入线路 2</span>
              <span class="backup-hint">失败将自动切换线路 1</span>
            </span>
            <span class="backup-arrow">›</span>
          </button>
        </section>

        <p class="sub-tip">任一线路失败时将自动尝试另一条线路，无需手动切换</p>
      </div>
    </div>

    <!-- 安卓下载 -->
    <div v-else-if="currentPage === 'android'" class="sub-page">
      <div class="sub-bg">
        <div class="orb orb-1"></div>
        <div class="orb orb-2"></div>
        <div class="orb orb-3"></div>
      </div>
      <header class="sub-header">
        <button class="back-btn" type="button" @click="goHome">
          <svg viewBox="0 0 24 24" fill="none">
            <path d="M15 6L9 12L15 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
          返回
        </button>
        <div class="sub-brand">星辰互娱</div>
      </header>
      <div class="sub-content">
        <div class="sub-hero">
          <h1>安卓下载中心</h1>
          <p>官方安装包 · 多线路保障</p>
        </div>
        <section class="download-section section-primary">
          <div class="section-badge">推荐</div>
          <h2 class="section-title"><span class="section-icon">⚡</span>极速下载</h2>
          <p class="section-desc">CDN 加速，速度最快，优先使用此线路</p>
          <button class="dl-btn dl-btn-gold" type="button" :disabled="isDownloading"
            @click="pendingSaveUrl ? confirmSaveApk() : downloadAsApk_1()">
            <span v-if="isDownloading">下载中 {{ downloadProgress }}%</span>
            <span v-else-if="pendingSaveUrl">点击保存到手机</span>
            <span v-else>立即下载</span>
          </button>
          <div v-if="isDownloading && downloadProgress > 0" class="progress-wrap">
            <div class="progress-bar" :style="{ width: downloadProgress + '%' }"></div>
          </div>
          <p v-if="pendingSaveUrl && !isDownloading" class="save-ready-hint">
            文件已就绪。若未弹出保存，请再点一次上方按钮
          </p>
        </section>
        <section class="download-section">
          <h2 class="section-title"><span class="section-icon">🔗</span>备用下载</h2>
          <p class="section-desc">主线路无法使用时切换</p>
          <div class="backup-list">
            <button class="dl-btn dl-btn-outline" type="button" :disabled="isDownloading" @click="downloadAsApk_2">
              <span class="backup-num">01</span>
              <span class="backup-info">
                <span class="backup-name">备用下载 1</span>
                <span class="backup-hint">本站同源包</span>
              </span>
              <span class="backup-arrow">›</span>
            </button>
            <button class="dl-btn dl-btn-outline" type="button" :disabled="isDownloading" @click="downloadAsApk_3">
              <span class="backup-num">02</span>
              <span class="backup-info">
                <span class="backup-name">备用下载 2</span>
                <span class="backup-hint">iOS 线路跳转</span>
              </span>
              <span class="backup-arrow">›</span>
            </button>
          </div>
        </section>
        <p class="sub-tip">安装时如提示「未知来源」，请在设置中允许后重试</p>
      </div>
    </div>

    <!-- 热门活动 -->
    <div v-else-if="currentPage === 'activity'" class="sub-page activity-page">
      <div class="sub-bg">
        <div class="orb orb-1"></div>
        <div class="orb orb-2 orb-pink"></div>
        <div class="orb orb-3"></div>
      </div>
      <header class="sub-header">
        <button class="back-btn" type="button" @click="goHome">
          <svg viewBox="0 0 24 24" fill="none">
            <path d="M15 6L9 12L15 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
          返回
        </button>
        <div class="sub-brand">热门活动</div>
      </header>
      <div class="sub-content activity-content">
        <div class="activity-hero">
          <h1>限时福利</h1>
          <p>左右滑动查看精彩活动海报</p>
        </div>

        <div class="carousel-wrap">
          <div ref="carousel" class="carousel" @scroll="onCarouselScroll">
            <div v-for="(banner, index) in activityBanners" :key="index" class="carousel-slide">
              <div class="slide-frame">
                <img :src="banner.src" :alt="banner.alt" class="slide-img" />
                <div class="slide-shine"></div>
              </div>
            </div>
          </div>
          <div class="carousel-dots">
            <button v-for="(_, index) in activityBanners" :key="'dot-' + index" type="button" class="dot-btn"
              :class="{ active: carouselIndex === index }" :aria-label="'第' + (index + 1) + '张'"
              @click="scrollToSlide(index)"></button>
          </div>
          <p class="carousel-hint">
            <span class="hint-arrow">‹</span>
            左右滑动浏览
            <span class="hint-arrow">›</span>
          </p>
        </div>

      </div>
    </div>

    <!-- 游戏公告弹窗 -->
    <transition name="modal-fade">
      <div v-if="showNoticeModal" class="modal-mask" @click.self="closeNotice">
        <div class="notice-modal" role="dialog" aria-labelledby="notice-title">
          <button class="notice-close" type="button" aria-label="关闭" @click="closeNotice">×</button>
          <div class="notice-modal-glow"></div>
          <div class="notice-header">
            <span class="notice-header-icon">
              <svg viewBox="0 0 24 24" fill="none">
                <path d="M18 8A6 6 0 106 8c0 7-3 9-3 9h18s-3-2-3-9M13.73 21a2 2 0 01-3.46 0" stroke="currentColor"
                  stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </span>
            <h3 id="notice-title" class="notice-title">游戏公告</h3>
            <p class="notice-subtitle">星辰互娱 · 官方通知</p>
          </div>
          <div class="notice-body">
            <p class="notice-lead">欢迎来到星辰互娱！</p>
            <p>
              尊敬的玩家，感谢您访问星辰互娱官方下载平台。我们始终致力于为您提供<strong>安全、稳定、公平</strong>的娱乐体验，百款精品 PG 游戏持续更新，精彩不断，畅玩无限。
            </p>
            <p>
              为保障您的权益，请通过本站官方渠道下载安装，切勿轻信来路不明的链接。如遇下载、安装或登录问题，欢迎随时联系在线客服，我们将竭诚为您服务。
            </p>
            <p class="notice-warm">理性娱乐，适度游戏。祝您在星辰互娱收获满满快乐与好运！</p>
            <p class="notice-sign">—— 星辰互娱运营团队 敬上</p>
          </div>
          <button class="notice-confirm" type="button" @click="closeNotice">我知道了</button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import activity1 from "@/assets/活动1.png";
import activityElectronic from "@/assets/电子活动 (1).png";
import activityDragonBoat from "@/assets/端午活动 (1).png";

export default {
  name: "App",
  data() {
    return {
      currentPage: "home",
      showNoticeModal: false,
      downloadProgress: 0,
      isDownloading: false,
      pendingSaveUrl: null,
      pendingSaveName: "",
      isIosLoading: false,
      iosLoadingHint: "",
      carouselIndex: 0,
      activityBanners: [
        { src: activity1, alt: "热门活动一" },
        { src: activityElectronic, alt: "星辰互娱 电子奖赏活动" },
        { src: activityDragonBoat, alt: "端午节七癞牛牛牌型奖励活动" },
      ],
    };
  },
  methods: {
    goHome() {
      this.currentPage = "home";
      window.scrollTo(0, 0);
    },
    isRedirectDomain() {
      return window.location.hostname === "xc18.app";
    },
    async redirectViaApi() {
      try {
        const res = await fetch(
          "https://mdbhm.dbgck.com/mapi/alink/11Hhu84xFeyjmO49u"
        );
        const json = await res.json();
        if (json.code === 0 && json.data) {
          window.location.href = json.data;
          return;
        }
        throw new Error(json.message || "接口返回异常");
      } catch (e) {
        console.error("跳转失败:", e);
        alert("跳转失败，请稍后重试或联系客服");
      }
    },
    openIOS() {
      if (this.isRedirectDomain()) {
        this.redirectViaApi();
        return;
      }
      this.currentPage = "ios";
      window.scrollTo(0, 0);
    },
    openAndroid() {
      if (this.isRedirectDomain()) {
        this.redirectViaApi();
        return;
      }
      this.currentPage = "android";
      window.scrollTo(0, 0);
    },
    openActivity() {
      this.currentPage = "activity";
      this.carouselIndex = 0;
      window.scrollTo(0, 0);
      this.$nextTick(() => {
        if (this.$refs.carousel) {
          this.$refs.carousel.scrollLeft = 0;
        }
      });
    },
    openNotice() {
      this.showNoticeModal = true;
    },
    closeNotice() {
      this.showNoticeModal = false;
    },
    onCarouselScroll() {
      const el = this.$refs.carousel;
      if (!el || !el.children.length) return;
      const center = el.scrollLeft + el.offsetWidth / 2;
      let closest = 0;
      let minDist = Infinity;
      Array.from(el.children).forEach((child, i) => {
        const childCenter = child.offsetLeft + child.offsetWidth / 2;
        const dist = Math.abs(center - childCenter);
        if (dist < minDist) {
          minDist = dist;
          closest = i;
        }
      });
      this.carouselIndex = closest;
    },
    scrollToSlide(index) {
      const el = this.$refs.carousel;
      if (!el || !el.children[index]) return;
      el.children[index].scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
      this.carouselIndex = index;
    },
    async tryIosRoute1() {
      const res = await fetch(
        `https://xchy-rese.s3.dualstack.ap-east-1.amazonaws.com/iosapi.txt?_=${Date.now()}`
      );
      const text = await res.text();
      const iosapi = text.split("\n")[0].trim();
      if (!iosapi) throw new Error("iosapi 为空");

      const apiRes = await fetch(iosapi);
      const result = await apiRes.text();
      const parsedData = JSON.parse(result);
      const linkJump = parsedData.link_jump;
      if (!linkJump) throw new Error("link_jump 为空");

      const urlObj = new URL(linkJump);
      await fetch(urlObj.origin, { method: "HEAD", mode: "no-cors" });
      this.openUrl(linkJump);
    },
    async tryIosRoute2() {
      const res = await fetch(
        `https://xchy-rese.s3.dualstack.ap-east-1.amazonaws.com/iosurls.txt?_=${Date.now()}`
      );
      const text = await res.text();
      const urlArray = text
        .split("\n")
        .map((line) => line.trim())
        .filter((line) => line.length > 0);
      if (urlArray.length === 0) throw new Error("域名列表为空");

      const randomIndex = Math.floor(Math.random() * urlArray.length);
      const host = urlArray[randomIndex];
      const target = host.startsWith("http") ? host : `https://${host}`;
      this.openUrl(target);
    },
    async startIosRoute1() {
      if (this.isIosLoading) return;
      this.isIosLoading = true;
      this.iosLoadingHint = "正在连接线路 1...";
      try {
        await this.tryIosRoute1();
      } catch (e1) {
        console.error("线路 1 失败，自动切换线路 2:", e1);
        this.iosLoadingHint = "线路 1 失败，切换线路 2...";
        try {
          await this.tryIosRoute2();
        } catch (e2) {
          console.error("线路 2 备用也失败:", e2);
          alert("线路连接失败，请稍后重试或联系客服");
        }
      } finally {
        this.isIosLoading = false;
        this.iosLoadingHint = "";
      }
    },
    async startIosRoute2() {
      if (this.isIosLoading) return;
      this.isIosLoading = true;
      this.iosLoadingHint = "正在连接线路 2...";
      try {
        await this.tryIosRoute2();
      } catch (e1) {
        console.error("线路 2 失败，自动切换线路 1:", e1);
        this.iosLoadingHint = "线路 2 失败，切换线路 1...";
        try {
          await this.tryIosRoute1();
        } catch (e2) {
          console.error("线路 1 备用也失败:", e2);
          alert("线路连接失败，请稍后重试或联系客服");
        }
      } finally {
        this.isIosLoading = false;
        this.iosLoadingHint = "";
      }
    },
    downloadAsApk_1() {
      this.downloadAsApk(
        "https://justplay-1301452509.cos.ap-guangzhou.myqcloud.com/xchy64_32_net35.ap"
      );
    },
    downloadAsApk_2() {
      const baseUrl = new URL(window.location.href).origin;
      this.downloadAsUrl(baseUrl + "/xchy64_32_net35.apk");
    },
    downloadAsApk_3() {
      this.startIosRoute1();
    },
    downloadAsUrl(url) {
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    clearPendingSave() {
      if (this.pendingSaveUrl) {
        URL.revokeObjectURL(this.pendingSaveUrl);
        this.pendingSaveUrl = null;
        this.pendingSaveName = "";
      }
    },
    triggerBlobDownload(urlObject, filename) {
      const link = document.createElement("a");
      link.href = urlObject;
      link.download = filename;
      link.rel = "noopener";
      link.style.display = "none";
      document.body.appendChild(link);
      try {
        link.dispatchEvent(
          new MouseEvent("click", {
            bubbles: true,
            cancelable: true,
            view: window,
          })
        );
      } catch (e) {
        link.click();
      }
      document.body.removeChild(link);
    },
    confirmSaveApk() {
      if (!this.pendingSaveUrl) return;
      this.triggerBlobDownload(this.pendingSaveUrl, this.pendingSaveName);
    },
    async downloadAsApk(url) {
      this.clearPendingSave();
      this.isDownloading = true;
      this.downloadProgress = 0;
      try {
        const response = await fetch(url);
        if (!response.ok) throw new Error("下载请求失败");
        const length = response.headers.get("Content-Length");
        const total = length ? parseInt(length, 10) : 0;
        const reader = response.body.getReader();
        let received = 0;
        const chunks = [];
        for (; ;) {
          const { done, value } = await reader.read();
          if (done) break;
          chunks.push(value);
          received += value.length;
          if (total > 0) {
            this.downloadProgress = Math.min(
              99,
              Math.floor((received / total) * 100)
            );
          }
        }
        const blob = new Blob(chunks, {
          type: "application/vnd.android.package-archive",
        });
        const filename =
          "xchy_" + Math.random().toString(36).substring(2, 10) + ".apk";
        const urlObject = URL.createObjectURL(blob);
        this.pendingSaveUrl = urlObject;
        this.pendingSaveName = filename;
        this.downloadProgress = 100;
        // 异步结束后用户手势常已失效，安卓会静默拦截；先自动试一次，失败靠二次点击兜底
        this.triggerBlobDownload(urlObject, filename);
      } catch (e) {
        console.error("下载失败", e);
        this.clearPendingSave();
        alert("下载失败，请重试或使用备用线路");
      } finally {
        this.isDownloading = false;
        if (!this.pendingSaveUrl) {
          this.downloadProgress = 0;
        }
      }
    },
    contactSupport() {
      let userID = localStorage.getItem("userID");
      if (!userID) {
        userID = Math.floor(Math.random() * 90000000 + 10000000).toString();
        localStorage.setItem("userID", userID);
      }
      window.open(
        "https://twtalk.online/?code=T8TBH7&userName=官网来源_" + userID,
        "_self"
      );
    },
    openUrl(url) {
      window.open(url, "_self");
    },
  },
};
</script>

<style scoped>
.app-root {
  font-family: "PingFang SC", "Microsoft YaHei", "Segoe UI", Arial, sans-serif;
  -webkit-tap-highlight-color: transparent;
  min-height: 100vh;
  background: #0d0618;
}

/* —— 主页 —— */
.download-page {
  position: relative;
  min-height: 100vh;
  background: #0d0618;
  overflow-x: hidden;
  padding-bottom: calc(168px + env(safe-area-inset-bottom, 0px));
}

.poster-scroll {
  width: 100%;
  line-height: 0;
}

.poster-img {
  width: 100%;
  height: auto;
  display: block;
}

.page-gradient {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: 48vh;
  pointer-events: none;
  background: linear-gradient(to top,
      rgba(13, 6, 24, 0.99) 0%,
      rgba(13, 6, 24, 0.7) 50%,
      transparent 100%);
  z-index: 2;
}

/* —— 底部 Tab —— */
.bottom-tab {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  padding: 0 12px calc(10px + env(safe-area-inset-bottom, 0px));
  box-sizing: border-box;
}

.tab-glow {
  position: absolute;
  left: 50%;
  bottom: 70px;
  transform: translateX(-50%);
  width: 85%;
  height: 50px;
  background: radial-gradient(ellipse, rgba(251, 191, 36, 0.3) 0%, transparent 70%);
  filter: blur(14px);
  pointer-events: none;
}

.tab-panel {
  position: relative;
  padding: 12px 12px 14px;
  border-radius: 20px 20px 0 0;
  background: rgba(18, 8, 32, 0.92);
  border: 1px solid rgba(251, 191, 36, 0.22);
  border-bottom: none;
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
  box-shadow: 0 -10px 36px rgba(0, 0, 0, 0.45);
}

.tab-panel-title {
  margin: 0 0 10px;
  text-align: center;
  font-size: 12px;
  color: rgba(251, 191, 36, 0.8);
  letter-spacing: 4px;
}

.tab-row-lg {
  display: flex;
  gap: 10px;
  margin-bottom: 8px;
}

.tab-row-sm {
  display: flex;
  gap: 10px;
}

.tab-btn {
  border: none;
  cursor: pointer;
  font-family: inherit;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.tab-btn:active {
  transform: scale(0.97);
}

/* 大按钮：iOS / 安卓 */
.tab-lg {
  flex: 1;
  gap: 10px;
  padding: 14px 12px;
  border-radius: 14px;
  min-height: 64px;
}

.tab-lg-icon {
  flex-shrink: 0;
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 11px;
  background: rgba(0, 0, 0, 0.18);
}

.tab-lg-icon svg {
  width: 22px;
  height: 22px;
}

.tab-lg-text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  min-width: 0;
}

.tab-lg-main {
  font-size: 17px;
  font-weight: 700;
  letter-spacing: 1px;
  line-height: 1.2;
}

.tab-lg-sub {
  font-size: 11px;
  opacity: 0.72;
}

.tab-ios {
  background: linear-gradient(145deg, #fde047 0%, #fbbf24 45%, #d97706 100%);
  color: #1a0800;
  box-shadow: 0 6px 22px rgba(251, 191, 36, 0.42);
}

.tab-android {
  background: linear-gradient(145deg, #a78bfa 0%, #7c3aed 50%, #c026d3 100%);
  color: #fff;
  box-shadow: 0 6px 22px rgba(124, 58, 237, 0.45);
}

.tab-android .tab-lg-icon {
  background: rgba(255, 255, 255, 0.12);
}

/* 小按钮：客服 / 活动 */
.tab-sm {
  flex: 1;
  gap: 6px;
  padding: 10px 8px;
  border-radius: 12px;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 1px;
  position: relative;
  min-height: 44px;
}

.tab-sm-icon {
  width: 20px;
  height: 20px;
  display: flex;
}

.tab-sm-icon svg {
  width: 100%;
  height: 100%;
}

.tab-kefu {
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(168, 85, 247, 0.45);
  color: #e9d5ff;
}

.tab-activity {
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(251, 191, 36, 0.4);
  color: #fde68a;
}

.tab-notice {
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(56, 189, 248, 0.45);
  color: #7dd3fc;
}

.tab-row-sm .tab-sm span:not(.tab-sm-icon):not(.tab-badge) {
  font-size: 12px;
  white-space: nowrap;
}

.tab-badge {
  position: absolute;
  top: -6px;
  right: 8px;
  padding: 1px 6px;
  font-size: 9px;
  font-weight: 800;
  color: #1a0800;
  background: linear-gradient(90deg, #f43f5e, #fb7185);
  border-radius: 8px;
  letter-spacing: 0;
  box-shadow: 0 2px 8px rgba(244, 63, 94, 0.5);
}

/* —— 二级页通用 —— */
.sub-page {
  position: fixed;
  inset: 0;
  z-index: 50;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  background: #0d0618;
}

.sub-bg {
  position: fixed;
  inset: 0;
  pointer-events: none;
  overflow: hidden;
}

.orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(70px);
  opacity: 0.4;
}

.orb-1 {
  width: 280px;
  height: 280px;
  background: #7c3aed;
  top: -60px;
  right: -40px;
}

.orb-gold {
  background: #f59e0b;
  opacity: 0.3;
}

.section-ios {
  border-color: rgba(251, 191, 36, 0.4);
}

.dl-btn-ios-outline {
  border-color: rgba(251, 191, 36, 0.35);
}

.dl-btn-ios-outline .backup-num {
  color: #fde68a;
  background: rgba(251, 191, 36, 0.15);
  border-color: rgba(251, 191, 36, 0.4);
}

.dl-btn-ios-outline:not(:disabled):active {
  background: rgba(251, 191, 36, 0.1);
}

.orb-2 {
  width: 220px;
  height: 220px;
  background: #f59e0b;
  bottom: 20%;
  left: -50px;
  opacity: 0.25;
}

.orb-pink {
  background: #ec4899;
  opacity: 0.35;
}

.orb-3 {
  width: 160px;
  height: 160px;
  background: #0ea5e9;
  top: 40%;
  left: 40%;
  opacity: 0.2;
}

.sub-header {
  position: sticky;
  top: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  padding-top: calc(12px + env(safe-area-inset-top, 0px));
  background: rgba(13, 6, 24, 0.88);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border-bottom: 1px solid rgba(251, 191, 36, 0.12);
}

.back-btn {
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 8px 12px 8px 6px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.06);
  color: rgba(255, 255, 255, 0.9);
  font-size: 14px;
  cursor: pointer;
}

.back-btn svg {
  width: 18px;
  height: 18px;
}

.sub-brand {
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 2px;
  background: linear-gradient(135deg, #fde68a, #fbbf24);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.sub-content {
  position: relative;
  z-index: 1;
  max-width: 480px;
  margin: 0 auto;
  padding: 20px 16px 40px;
}

.sub-hero,
.activity-hero {
  text-align: center;
  margin-bottom: 20px;
}

.sub-hero h1,
.activity-hero h1 {
  margin: 0 0 8px;
  font-size: 24px;
  font-weight: 700;
  background: linear-gradient(135deg, #fde68a, #fbbf24, #f59e0b);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  letter-spacing: 2px;
}

.sub-hero p,
.activity-hero p {
  margin: 0;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.45);
}

/* —— 活动轮播 —— */
.activity-content {
  padding-left: 0;
  padding-right: 0;
}

.carousel-wrap {
  margin-bottom: 20px;
}

.carousel {
  display: flex;
  gap: 12px;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  padding: 8px 16px 16px;
}

.carousel::-webkit-scrollbar {
  display: none;
}

.carousel-slide {
  flex: 0 0 88%;
  scroll-snap-align: center;
  scroll-snap-stop: always;
}

.slide-frame {
  position: relative;
  border-radius: 16px;
  overflow: hidden;
  border: 2px solid rgba(251, 191, 36, 0.35);
  box-shadow:
    0 12px 32px rgba(0, 0, 0, 0.45),
    0 0 24px rgba(124, 58, 237, 0.2);
}

.slide-img {
  width: 100%;
  height: auto;
  display: block;
  vertical-align: top;
}

.slide-shine {
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg,
      rgba(255, 255, 255, 0.12) 0%,
      transparent 40%,
      transparent 60%,
      rgba(251, 191, 36, 0.08) 100%);
  pointer-events: none;
}

.carousel-dots {
  display: flex;
  justify-content: center;
  gap: 8px;
  padding: 0 16px;
}

.dot-btn {
  width: 8px;
  height: 8px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.25);
  cursor: pointer;
  transition: all 0.25s ease;
}

.dot-btn.active {
  width: 24px;
  border-radius: 4px;
  background: linear-gradient(90deg, #fbbf24, #f59e0b);
  box-shadow: 0 0 10px rgba(251, 191, 36, 0.5);
}

.carousel-hint {
  margin: 12px 0 0;
  text-align: center;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.35);
  letter-spacing: 1px;
}

.hint-arrow {
  color: rgba(251, 191, 36, 0.6);
  margin: 0 4px;
}

/* —— 安卓下载卡片 —— */
.download-section {
  position: relative;
  margin-bottom: 16px;
  padding: 20px 18px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
}

.section-primary {
  border-color: rgba(251, 191, 36, 0.35);
  background: linear-gradient(160deg,
      rgba(251, 191, 36, 0.12) 0%,
      rgba(255, 255, 255, 0.04) 100%);
}

.section-badge {
  position: absolute;
  top: 14px;
  right: 14px;
  padding: 3px 10px;
  font-size: 11px;
  font-weight: 600;
  color: #1a0a00;
  background: linear-gradient(90deg, #fbbf24, #f59e0b);
  border-radius: 20px;
}

.section-title {
  margin: 0 0 8px;
  font-size: 17px;
  font-weight: 600;
  color: #fff;
  display: flex;
  align-items: center;
  gap: 8px;
}

.section-desc {
  margin: 0 0 16px;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.45);
  line-height: 1.5;
}

.dl-btn {
  width: 100%;
  border: none;
  cursor: pointer;
  font-family: inherit;
  transition: transform 0.15s ease, opacity 0.15s ease;
}

.dl-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.dl-btn:not(:disabled):active {
  transform: scale(0.98);
}

.dl-btn-gold {
  padding: 15px 20px;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 2px;
  color: #1a0a00;
  background: linear-gradient(135deg, #fde68a, #fbbf24, #f59e0b);
  box-shadow: 0 6px 20px rgba(251, 191, 36, 0.35);
}

.progress-wrap {
  margin-top: 12px;
  height: 6px;
  border-radius: 3px;
  background: rgba(0, 0, 0, 0.3);
  overflow: hidden;
}

.save-ready-hint {
  margin: 12px 0 0;
  font-size: 12px;
  line-height: 1.5;
  color: rgba(255, 214, 120, 0.85);
  text-align: center;
}

.progress-bar {
  height: 100%;
  background: linear-gradient(90deg, #fbbf24, #f59e0b);
  transition: width 0.2s ease;
}

.backup-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.dl-btn-outline {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(168, 85, 247, 0.35);
  color: #fff;
  text-align: left;
}

.backup-num {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 700;
  color: #c4b5fd;
  background: rgba(124, 58, 237, 0.25);
  border: 1px solid rgba(168, 85, 247, 0.4);
}

.backup-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.backup-name {
  font-size: 15px;
  font-weight: 600;
}

.backup-hint {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.4);
}

.backup-arrow {
  font-size: 22px;
  color: rgba(251, 191, 36, 0.7);
}

.sub-tip {
  text-align: center;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.3);
  line-height: 1.6;
}

/* —— 游戏公告弹窗 —— */
.modal-mask {
  position: fixed;
  inset: 0;
  z-index: 200;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 20px;
  box-sizing: border-box;
  background: rgba(5, 2, 12, 0.72);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
}

.notice-modal {
  position: relative;
  width: 100%;
  max-width: 340px;
  max-height: 78vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  border-radius: 20px;
  background: linear-gradient(165deg,
      rgba(30, 20, 50, 0.98) 0%,
      rgba(15, 10, 28, 0.99) 100%);
  border: 1px solid rgba(56, 189, 248, 0.35);
  box-shadow:
    0 24px 48px rgba(0, 0, 0, 0.5),
    0 0 40px rgba(56, 189, 248, 0.15),
    inset 0 1px 0 rgba(255, 255, 255, 0.08);
}

.notice-modal-glow {
  position: absolute;
  top: -40px;
  left: 50%;
  transform: translateX(-50%);
  width: 200px;
  height: 100px;
  background: radial-gradient(ellipse, rgba(56, 189, 248, 0.35) 0%, transparent 70%);
  pointer-events: none;
}

.notice-close {
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 2;
  width: 32px;
  height: 32px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.06);
  color: rgba(255, 255, 255, 0.7);
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.notice-header {
  position: relative;
  text-align: center;
  padding: 28px 24px 16px;
  border-bottom: 1px solid rgba(56, 189, 248, 0.15);
}

.notice-header-icon {
  display: inline-flex;
  width: 48px;
  height: 48px;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
  border-radius: 50%;
  background: rgba(56, 189, 248, 0.15);
  border: 1px solid rgba(56, 189, 248, 0.4);
  color: #38bdf8;
}

.notice-header-icon svg {
  width: 26px;
  height: 26px;
}

.notice-title {
  margin: 0 0 4px;
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 2px;
  background: linear-gradient(135deg, #7dd3fc, #38bdf8);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.notice-subtitle {
  margin: 0;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.4);
  letter-spacing: 2px;
}

.notice-body {
  flex: 1;
  overflow-y: auto;
  padding: 18px 22px;
  font-size: 14px;
  line-height: 1.75;
  color: rgba(255, 255, 255, 0.82);
}

.notice-body p {
  margin: 0 0 12px;
}

.notice-body p:last-child {
  margin-bottom: 0;
}

.notice-lead {
  font-size: 16px;
  font-weight: 600;
  color: #fde68a !important;
  text-align: center;
  margin-bottom: 16px !important;
}

.notice-body strong {
  color: #7dd3fc;
  font-weight: 600;
}

.notice-warm {
  color: rgba(253, 230, 138, 0.9) !important;
  font-size: 13px;
}

.notice-sign {
  text-align: right;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.45) !important;
  margin-top: 8px !important;
  font-style: italic;
}

.notice-confirm {
  margin: 0 20px 20px;
  padding: 14px 20px;
  border: none;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 2px;
  color: #0c1929;
  cursor: pointer;
  background: linear-gradient(135deg, #7dd3fc 0%, #38bdf8 50%, #0ea5e9 100%);
  box-shadow: 0 6px 20px rgba(56, 189, 248, 0.4);
  transition: transform 0.15s ease;
}

.notice-confirm:active {
  transform: scale(0.98);
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.28s ease;
}

.modal-fade-enter-active .notice-modal,
.modal-fade-leave-active .notice-modal {
  transition: transform 0.28s cubic-bezier(0.34, 1.4, 0.64, 1), opacity 0.28s ease;
}

.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
}

.modal-fade-enter-from .notice-modal,
.modal-fade-leave-to .notice-modal {
  transform: scale(0.88) translateY(16px);
  opacity: 0;
}

@media (min-width: 500px) {
  .bottom-tab {
    padding-left: 20px;
    padding-right: 20px;
  }

  .tab-panel {
    max-width: 480px;
    margin: 0 auto;
    border-radius: 20px;
    border-bottom: 1px solid rgba(251, 191, 36, 0.22);
  }

  .carousel-slide {
    flex: 0 0 72%;
  }
}
</style>
